module.exports = __webpack_public_path__ + "img/la_fab.1761b11d.jpg";